var ApiQueriesKeys;
(function (ApiQueriesKeys) {
    ApiQueriesKeys["CATEGORY"] = "cat";
    ApiQueriesKeys["STEP"] = "step";
    ApiQueriesKeys["PAGE"] = "page";
})(ApiQueriesKeys || (ApiQueriesKeys = {}));
export default ApiQueriesKeys;
